<template lang="pug">
div( v-if="listBlocks && listBlocks.length" )
  div.container-list
    div.dsp-flex( v-for="block in listBlocks" ) 
      div.container-block
        goal-icon( :title="block.title" :height="48" :width="48")
        div
          span.text-14 {{ block.title }}
        span.text-12.mb-2 {{ block.completed_date }}
        div.goal-status
          span.text-12 {{ block.full_amount }} {{convertToValueLabel('RUR')}}
div(v-else).no-completedGoals
  span.text-16 У вас нет завершённых целей
</template>

<script>

export default {
  name: "ScrollListCompletedGoals",
  props: {
    listBlocks: Array
  },

  methods: {
    returnGoalIcon(title) {
      switch(title) {
        case "Велосипед":
          return "bike.svg"
        case "Nintendo Switch":
          return "nintendo.svg"
        case "Курс":
          return "course.svg"
        case "Наушники":
          return "headphones.svg"
        case "Коньки":
          return "skates.svg"
        default:
          return "nintendo.svg"
      }
    }
  }
}
</script>

<style scoped>
.container-list {
  padding: 10px 0px 50px 22px;
  overflow-x: scroll;
  display: -webkit-box;
  width: 100%;
  min-height: 100px;
  height: auto;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.container-list::-webkit-scrollbar {
  width: 0px;
  background-color: transparent;
}
.container-block {
  margin-right: 40px;
  width: 83px;
  height: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.price {
  margin-left: auto;
  color: #FF9900;
}
.goal-status {
  height: 24px;
  border-radius: 9999px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #DCFCE7;
  color: #16A34A;
  padding: 5px 10px;
}
.goal-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
}
.bg-pink {
  background: linear-gradient(90deg, #C084FC 0%, #F472B6 100%);
}
.bg-green {
  background: linear-gradient(90deg, #4ADE80 0%, #34D399 100%);
}
.bg-blue {
  background: linear-gradient(90deg, #60A5FA 0%, #22D3EE 100%);
}
.icon {
  padding: 16px 14px
}
.no-completedGoals {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 50px;
}
</style>